module.exports = Enumerable;